import styled from 'styled-components';
import { Button } from '@attain-sre/attain-design-system';

export const SelectionActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 6px 15px;
  background: #fde8ec;
  border-radius: 8px;
  border: 1px solid #f5c2cb;
`;

export const SelectionActionBarLeft = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  font-family: Calibre-Regular, sans-serif;
  font-size: 15px;
  color: rgb(26, 23, 28);
`;

export const SelectionCountText = styled.span`
  font-family: Calibre-Semibold, sans-serif;
  font-size: 16px;
`;

export const SelectionActionsRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

/** Red delete control: keep white label + icon when disabled (e.g. mutation in flight). */
export const ToolbarDeleteButton = styled(Button)`
  && {
    background-color: #e53935;
    color: #fff;
    box-shadow: none;
  }
  &&:hover {
    background-color: #c62828;
    color: #fff;
  }
  &&:disabled {
    background-color: #e53935 !important;
    color: #fff !important;
    opacity: 0.72 !important;
  }
  && .toolbar-delete-inner,
  && .toolbar-delete-inner svg {
    color: #fff !important;
    opacity: 1 !important;
  }
`;
